import React, { useEffect, useRef, useState } from "react";
import { FaChevronDown } from "react-icons/fa";

/** Hover-friendly select for upload/edit dialogs (native select cannot open on hover). */
const CLOSE_MS = 140;

function toOptions(options) {
  return (options || []).map((opt) =>
    typeof opt === "string" ? { value: opt, label: opt } : opt,
  );
}

export default function CompanyFormsDialogSelect({
  id,
  label,
  value,
  onChange,
  options,
  disabled = false,
}) {
  const [open, setOpen] = useState(false);
  const closeTimer = useRef(null);
  const opts = toOptions(options);
  const selected = opts.find((o) => o.value === value) || opts[0];

  const cancelClose = () => {
    if (closeTimer.current) {
      clearTimeout(closeTimer.current);
      closeTimer.current = null;
    }
  };

  const scheduleClose = () => {
    cancelClose();
    closeTimer.current = setTimeout(() => setOpen(false), CLOSE_MS);
  };

  useEffect(() => () => cancelClose(), []);

  const hoverProps = {
    onMouseEnter: () => {
      cancelClose();
      if (!disabled && opts.length) setOpen(true);
    },
    onMouseLeave: scheduleClose,
  };

  return (
    <div className="company-forms-dialog-select" {...hoverProps}>
      {label ? (
        <label className="company-forms-dialog-label" htmlFor={id}>
          {label}
        </label>
      ) : null}
      <button
        id={id}
        type="button"
        disabled={disabled}
        className={`company-forms-dialog-select-trigger${
          open ? " company-forms-dialog-select-trigger--open" : ""
        }`}
        aria-expanded={open}
        aria-haspopup="listbox"
        onClick={() => setOpen((wasOpen) => !wasOpen)}
      >
        <span className="company-forms-dialog-select-value">
          {selected?.label || "Select…"}
        </span>
        <FaChevronDown size={10} className="company-forms-dialog-select-chevron" aria-hidden />
      </button>
      {open ? (
        <div className="company-forms-dialog-select-menu" role="listbox" {...hoverProps}>
          {opts.map((opt) => (
            <button
              key={String(opt.value)}
              type="button"
              role="option"
              aria-selected={opt.value === value}
              className={`company-forms-dialog-select-option${
                opt.value === value ? " company-forms-dialog-select-option--active" : ""
              }`}
              onClick={() => {
                onChange(opt.value);
                setOpen(false);
              }}
            >
              {opt.label}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
